import React, { useState } from 'react';
import { Col, Row, getItemWithExpiration } from '../../lib/utils';
import { colors } from '../../lib/colors';
import { Subtitle1Bold, Body2Regular } from '../../lib/font';
import MemberStatsTab from './tabs/MemberStatsTab';
import CheckinStatsTab from './tabs/CheckinStatsTab';
import SubscriptionStatsTab from './tabs/SubscriptionStatsTab';

type StatsTab = 'member' | 'checkin' | 'subscription';

const TABS: { code: StatsTab; label: string }[] = [
    { code: 'member', label: '회원 통계' },
    { code: 'checkin', label: '출석 통계' },
    { code: 'subscription', label: '이용권 통계' },
];

const CenterStatsPage = ({ createAlert }: { createAlert: any }) => {
    const [authObject] = useState(getItemWithExpiration('authObject'));
    const centerId = authObject?.centerId;
    const [activeTab, setActiveTab] = useState<StatsTab>('member');
    const [showGuide, setShowGuide] = useState(() => localStorage.getItem('guide_centerStats') !== 'hidden');

    return (
        <Col
            style={{
                width: '100%',
                height: '100%',
                backgroundColor: '#F8FAFC',
                marginTop: 64,
            }}
        >
            <Col className="w-full pt-[36px] px-[48px] pb-[48px]">
                <Row style={{ alignItems: 'center', gap: 8 }}>
                    <Subtitle1Bold>센터 통계</Subtitle1Bold>
                    {!showGuide && (
                        <button onClick={() => { setShowGuide(true); localStorage.removeItem('guide_centerStats'); }}
                            style={{ width: 22, height: 22, borderRadius: '50%', border: '1.5px solid #93C5FD', backgroundColor: '#EFF6FF', color: '#3B82F6', fontSize: 12, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>?</button>
                    )}
                </Row>
                {showGuide && (
                    <Col style={{ marginTop: 12, padding: '18px 22px', backgroundColor: '#EFF6FF', borderRadius: 12, border: '1px solid #BFDBFE', position: 'relative' }}>
                        <button onClick={() => { setShowGuide(false); localStorage.setItem('guide_centerStats', 'hidden'); }}
                            style={{ position: 'absolute', top: 10, right: 14, background: 'none', border: 'none', fontSize: 16, color: '#93C5FD', cursor: 'pointer' }}>✕</button>
                        <span style={{ fontSize: 14, fontWeight: 700, color: '#1E40AF', marginBottom: 6 }}>센터 통계란?</span>
                        <Col style={{ gap: 3, fontSize: 13, color: '#1E40AF', lineHeight: 1.7 }}>
                            <span>센터의 <b>회원 현황, 출석 추이, 이용권 통계</b>를 한곳에서 확인하는 대시보드입니다.</span>
                            <span>탭을 전환하여 원하는 통계 항목을 볼 수 있습니다.</span>
                        </Col>
                    </Col>
                )}

                {/* 탭 */}
                <Row className="mt-[24px] gap-[6px]">
                    {TABS.map((tab) => {
                        const isActive = activeTab === tab.code;
                        return (
                            <button
                                key={tab.code}
                                style={{
                                    padding: '10px 22px',
                                    fontSize: 14,
                                    fontWeight: isActive ? 600 : 400,
                                    borderRadius: 8,
                                    border: isActive ? '1.5px solid #2563EB' : '1px solid #E1E4E6',
                                    backgroundColor: isActive ? '#EFF6FF' : '#FFFFFF',
                                    color: isActive ? '#2563EB' : '#6B7280',
                                    cursor: 'pointer',
                                    transition: 'all 0.15s',
                                }}
                                onClick={() => setActiveTab(tab.code)}
                            >
                                {tab.label}
                            </button>
                        );
                    })}
                </Row>

                {/* 탭 콘텐츠 */}
                <Col className="mt-[24px]">
                    {activeTab === 'member' && <MemberStatsTab centerId={centerId} />}
                    {activeTab === 'checkin' && <CheckinStatsTab centerId={centerId} />}
                    {activeTab === 'subscription' && <SubscriptionStatsTab centerId={centerId} />}
                </Col>
            </Col>
        </Col>
    );
};

export default CenterStatsPage;
